import { QueryClient as rqQueryClient } from 'react-query';
export const QueryClient = rqQueryClient;
//# sourceMappingURL=QueryClient.js.map